import http from '@/plugins/axios/axios';

export default class DispositivoService {

    salvar(requisicao) {       
        return http.post('/api/v1/dispositivo/salvar', requisicao);
    }

    gerarCodigoAtivacao(requisicao) {       
        return http.post('/api/v1/dispositivo/gerar-codigo-ativacao', requisicao);
    }

    gerarCodigoRedefinirSenha(requisicao) {       
        return http.post('/api/v1/dispositivo/gerar-codigo-recuperar-senha', requisicao);
    }

    atualizarPermissoes(requisicao) {       
        return http.post('/api/v1/dispositivo/atualizar-permissoes', requisicao);
    }

    excluir(requisicao) {       
        return http.post('/api/v1/dispositivo/excluir', requisicao);
    }

    buscarQuantidade(requisicao) {       
        return http.post('/api/v1/dispositivo/buscarQuantidade', requisicao);
    }
    
    listar(requisicao) {       
        return http.post('/api/v1/dispositivo/listar', requisicao);
    }
}